import React from 'react';
import './HelpPopup.css';
import { X } from 'lucide-react'; // Ikona do zamknięcia

const HelpPopup = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="help-popup-overlay" onClick={onClose}>
      <div className="help-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="help-popup-close-btn" onClick={onClose}>
          <X size={24} />
        </button>
        <div className="help-popup-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default HelpPopup;
